export default {
    File: {
        // 图片上传
        upload: "/file/file/upload"
    },
    Content: {
        downloadFileStream: "/content/v1/FileResource/DownloadFileStream"
    }
}
